<template>
  <div class="main">
    <div class="content">
      <div class="form-row-line">
        <div class="form-field">
          <button @click="addRedaction">
            Создать редакцию
          </button>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content_title">Список редакций: {{ contractTypeName }}</div>
      <div class="content_row col-4 center bold">
        <div>Название</div>
        <div>Категория</div>
        <div>Поселок</div>
      </div>
      <div
        class="content_row col-4 center"
        v-for="(contractType, key) in contractTypesShow"
        :key="key"
      >
        <button @click="detailContractType(contractType.ID)">
          Подробности
        </button>
        <div>{{ contractType.NAME }}</div>
        <div>{{ contractType.CATEGORY }}</div>
        <div>{{ contractType.VILLAGE_NAME }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "ContractTypeListRedaction",
  components: {},
  data() {
    return {
      parentContractTypeData: {},
      id: this.$route.params.id,
      contractTypeName: "",
      url: config.backend_url,
      contractTypes: []
    };
  },
  computed: {
    contractTypesShow: function() {
      return this.contractTypes.filter(type => {
        return parseInt(type.PARENT_ID) === parseInt(this.id);
      });
    }
  },
  watch: {
    id() {
      this.getParentContractType();
      this.getContractType();
    }
  },
  methods: {
    detailContractType: function(id) {
      this.$router.push({
        name: "ContractTypeListRedaction",
        params: { id: id }
      });
      this.id = id;
    },
    addRedaction: function() {
      this.$router.push({
        name: "ContractTypeAddRedaction",
        params: { id: this.id }
      });
    },
    getContractType: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "agreementtypelist/get-user-agreement-type/",
          data: { parentId: this.id },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) {
            let reverseData = [];
            let reverseKey = Object.keys(data)
              .sort()
              .reverse();
            reverseKey.forEach(function(key) {
              reverseData.push(data[key]);
            });
            this.contractTypes = reverseData;
          }
        });
    },
    getParentContractType: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "agreementtypelist/get/",
          filter: { ID: this.id },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) {
            this.contractTypeName = data[this.id].NAME;
            this.parentContractTypeData = data[this.id];
          }
        });
    }
  },
  created() {
    this.getParentContractType();
    this.getContractType();
  }
};
</script>
